import merge from './merge'

export default function(hideList) {
  let list = [
    merge({ name: 'Input', label: '单行文本', setting: {
      prefixIcon: '',
      suffixIcon: ''
    }}),
    merge({ name: 'Textarea', label: '多行文本', setting: { rows: 2 }}),
    merge({ name: 'Input', label: '数字', placeholder: '请输入数字', type: 'number', setting: {
      prefixIcon: '',
      suffixIcon: ''
    }}),
    merge({ name: 'Phone', label: '手机号', placeholder: '请输入手机号', setting: {
      prefixIcon: 'el-icon-mobile',
      suffixIcon: ''
    }}),
    merge({ name: 'Password', label: '密码', placeholder: '请输入密码', setting: {
      prefixIcon: 'el-icon-lock',
      suffixIcon: ''
    }})
  ]
  if (typeof hideList === 'string') {
    list = list.filter(item => item.name !== hideList)
  } else if (Object.prototype.toString.call(hideList) === '[object Array]' && hideList.length) {
    list = list.filter(item => !hideList.find(i => i === item.name))
  }
  return list
}
